import { gql } from 'graphql-request'

export const GetNotesAndContactsGql = gql`
  query notesAndContacts($recordNumber: String!, $stationInFarmGroup: Boolean!) {
    notesAndContacts(stationRecordNumber: $recordNumber, stationInFarmGroup: $stationInFarmGroup) {
      offerNotes
      offerContactOptions {
        firstName
        lastName
        roles
        email
        mobilePhone
        crmLink
        sendEmail
        sendSms
        sendReminders
        isStaffMember
      }
    }
  }
`
